(function () {
  'use strict';

  function create(adapter) {
    let sequence = 0;

    async function refresh(state, updatedCart) {
      const ticket = ++sequence;
      const revision = window.AboffsRegion.getRevision();
      const current = () => ticket === sequence && revision === window.AboffsRegion.getRevision();
      const rows = Array.from(adapter.rows());
      if (!rows.length) {
        if (adapter.empty) adapter.empty();
        return;
      }
      adapter.prepare(rows);
      try {
        const cart = updatedCart || (await adapter.readCart());
        if (!current()) return;
        const quote = state && adapter.readQuote ? await adapter.readQuote(cart, state) : null;
        if (!current()) return;
        const entries = await Promise.all(rows.map((row) => adapter.priceRow(row, cart, state, quote)));
        if (!current()) return;
        const uniqueEntries = adapter.deduplicate(entries.filter(Boolean));
        adapter.render(entries.filter(Boolean), uniqueEntries, cart, state);
      } catch (error) {
        if (current()) adapter.error(error);
      }
    }

    return Object.freeze({ refresh });
  }

  window.AboffsCartPricing = Object.freeze({ create });
})();
